import request from 'api/requestUtils'

export function putCart(transactionKey, cart) {
  return request.put(`/api/carts/${transactionKey}`, cart, { credentials: 'include' })
}

export function finalizeCart(transactionKey) {
  return request.patch(`/api/carts/${transactionKey}`, { op: 'finalize' }, { credentials: 'include' })
}

export function putNewCheckoutCart(transactionKey, cart) {
  return request.put(`/api/carts/v2/${transactionKey}`, cart, { credentials: 'include' })
}

export function getCartItems(cartId): Promise<App.Checkout.Item[]> {
  return request.get<{items: App.Checkout.Item[]}>(`/api/carts/v2/${cartId}/items`, { credentials: 'include' }).then((res) => res.items)
}
